// 饼图与表格（蛋白亚细胞定位）
import ChartTemplate from '../ChartTemplate';
import ChartOptionBuilder from '@/plugins/ChartOptionBuilder';

export default {
  extends: ChartTemplate,
  data () {
    return { extCPT: () => import('./ExtendComponent.vue') }
  },
  computed: {
    extCPTProps () {
      return { dataSourceParam: this.dataSourceParam, dataSource: this.dataSource }
    }
  },
  methods: {
    // initOptionAfter () {
    //   let option = { plotOptions: { pie: { point: { events: { click: this.pointClick } } } } };
    //   this.Utility.deepMerge(this.chartOption, option);
    // },
    // // =============== 图表事件
    // pointClick (e) {
    //   let rowIndex = e.point.index;
    //   this.$refs.extCPT.showC2(rowIndex);
    // },


    // 扩展组件的表格行勾选事件
    onExtCPTChanged (srs) {
      // if (this.srcSeriesData == null) this.srcSeriesData = this.Utility.clone(this.chartOption.series[0].data);
      // let srcRows = this.srcSeriesData;
      // let newRows = [];
      // for (let i = 0; i < srcRows.length; i++) {
      //   if (sri.indexOf(i) != -1) newRows.push(srcRows[i]);
      // }
      // let option = { series: [{ data: newRows }] };
      // this.chart.update(option);
      let cob = new ChartOptionBuilder(this.tool.type, srs, { ...this.config, title: false }).get();
      let option = { series: cob.series };
      this.chart.update(option);
    }
  }
}